import { createContext, useContext } from 'react';
import type { AdminMe } from '../queries/admin';

/**
 * The admin the API has admitted, as it sees them. Available anywhere inside
 * the gate; used for the little that depends on identity, such as not
 * offering to remove yourself.
 */
export const AdminContext = createContext<AdminMe | null>(null);

export function useAdminMe(): AdminMe {
  const value = useContext(AdminContext);
  if (!value) throw new Error('useAdminMe must be used inside the admin gate.');
  return value;
}
